//theme
import { theme as fashionTheme } from 'shared/styles/theme/fashionTheme';

//data
import data from 'shared/components/MyAccount/data';

export const buildConfig = {
  LOGO: {
    MWEB: {
      HEIGHT: 32,
      WIDTH: 58,
      URL: 'https://images-static.nykaa.com/fashion-images/pub/media/nykaa-logo.svg',
    },
    DWEB: {
      HEIGHT: 24,
      WIDTH: 108,
      URL: 'https://images-static.nykaa.com/fashion-images/pub/media/logo-full.svg',
    },
    FOOTER: {
      HEIGHT: 24,
      WIDTH: 108,
      URL: 'https://images-static.nykaa.com/fashion-images/pub/media/footer-logo.svg',
    },
    COUPONS: {
      HEIGHT: 24,
      WIDTH: 40,
      URL: 'https://images-static.nykaa.com/fashion-images/pub/media/nykaa-logo.svg',
    },
    LOGO_ALT_TEXT: "Nykaa Fashion",
  },
  FAVICON: 'https://images-static.nykaa.com/fashion-images/media/favicon96x96.ico',
  PWA_ICONS: {
    ICON_512: 'https://images-static.nykaa.com/fashion-images/pub/media/pwa-512x512.png',
    ICON_192: 'https://images-static.nykaa.com/fashion-images/pub/media/pwa-192x192.png',
    ICON_144: 'https://images-static.nykaa.com/fashion-images/pub/media/pwa-144x144.png',
    ICON_32: 'https://images-static.nykaa.com/fashion-images/pub/media/pwa-32x32.png',
    ICON_16: 'https://images-static.nykaa.com/fashion-images/pub/media/pwa-16x16.png',
  },
  THEME: fashionTheme,
  MY_ACCOUNT_DATA: data,
};
